import { StrictRouteConfig } from "@/router/router";

export const deskRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/offices/:officeId/desks",
        name: "desks-page",
        component: () => import(/* webpackChunkName: "office" */ "@/views/desk/desks-page.vue"),
        meta: {
            requiresAuth: true,
            label: "Desks",
            includeInNavigation: false,
            icon: "briefcase-outline",
            matchExact: true,
            path: ["dashboard", "offices", "office", "desks-page"],
            includeInSubNavigation: true,
            order: 10,
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/desks/:deskId",
        name: "desk",
        component: () => import(/* webpackChunkName: "office" */ "@/views/desk/desk.vue"),
        meta: {
            requiresAuth: true,
            label: "Desk",
            includeInNavigation: false,
            icon: "briefcase-outline",
            matchExact: true,
            path: ["dashboard", "offices", "office", "desks-page"],
            includeInSubNavigation: true,
            order: 10,
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/desks/:deskId/reservations",
        name: "desk-reservations",
        component: () => import(/* webpackChunkName: "office" */ "@/views/desk/desk-reservations.vue"),
        meta: {
            requiresAuth: true,
            label: "Desk",
            includeInNavigation: false,
            icon: "briefcase-outline",
            matchExact: true,
            path: ["dashboard", "offices", "office", "desks-page"],
            includeInSubNavigation: true,
            order: 10,
        },
    },
];
